/**
 * @generated SignedSource<<f14eeb03a61a621b5a0a40edd7f40fc7>>
 * @relayHash a304f862c25c4437675c2b455f86efb8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec604bda47db6f4d2ed08ea4adac10371f0d77ad41a466a7e7b6bbe14d72145b

import { ConcreteRequest } from 'relay-runtime';
export type nexusAccountOverviewPageQuery$variables = {
  account: string;
};
export type nexusAccountOverviewPageQuery$data = {
  readonly account: {
    readonly __typename: string;
  };
};
export type nexusAccountOverviewPageQuery = {
  response: nexusAccountOverviewPageQuery$data;
  variables: nexusAccountOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "nexusAccountOverviewPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": "account",
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "nexusAccountOverviewPageQuery",
    "selections": [
      {
        "alias": "account",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a304f862c25c4437675c2b455f86efb8",
    "id": "ec604bda47db6f4d2ed08ea4adac10371f0d77ad41a466a7e7b6bbe14d72145b",
    "metadata": {},
    "name": "nexusAccountOverviewPageQuery",
    "operationKind": "query",
    "text": "query nexusAccountOverviewPageQuery(\n  $account: String!\n) {\n  account: accountBySlug(slug: $account) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5147836ec8b1a42acd80563300e08762";

export default node;
